// Draw Styles
export const drawInactiveColor = '#fff';
export const drawActiveColor = '#31B4F2';
export const drawFillOpacity = 0.3;

// Coordinates for the center of the US
export const USA_CENTER_COORDINATES = [-98.5795, 39.8283];
export const EARTH_ZOOM = [1];

export const DEFAULT_ZOOM = [16];
export const NATIONAL_ZOOM = [4];
export const MAX_ZOOM = 20;
export const MIN_ZOOM = 1;

export const PROPERTY_LANDING_MAP_CORDS = 'PROPERTY_LANDING_MAP_CORDS';
export const PROPERTY_CREATE_STATE = 'PROPERTY_CREATE_STATE';
export const DEFAULT_ORG_MAP_VIEW = 'DEFAULT_ORG_MAP_VIEW';
export const NEW_USER = 'NEW_USER';

export const DEFAULT_FLY_TO_OPTIONS = {
  speed: 1.8,
  maxDuration: 1
};

export const UPDATE_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete'
};

export const KEY_CODES = {
  BACKSPACE: 8,
  DELETE: 46,
  ESC: 27
};

export const LAND_TYPES = {
  FARM: 'farm',
  FIELD: 'field',
  CROP_ZONE: 'cropzone'
};

export const PLURAL_LAND_TYPES = {
  FIELD: 'fields',
  CROP_ZONE: 'cropzones'
};

export const LAND_TYPE_DEPTHS = [LAND_TYPES.FIELD, LAND_TYPES.CROP_ZONE];

export const MAP_HISTORY_FEATURE_TYPES = {
  IMPORT: 'import_feature',
  ADD: 'add_feature',
  REMOVE: 'remove_feature'
};

export const propertyOwnerOptions = [];

export const stateOptions = [
  {
    key: 'TN',
    value: 'Tennessee'
  },
  { key: 'KY', value: 'Kentucky' }
];

export const countyOptions = [
  { key: 'Davidson', value: 'Davidson County', parent: 'TN' },
  { key: 'Henry', value: 'Henry County', parent: 'TN' },
  { key: 'Benton', value: 'Benton County', parent: 'KY' },
  { key: 'Calloway', value: 'Calloway County', parent: 'KY' },
  { key: 'Graves', value: 'Graves County', parent: 'KY' },
  { key: 'Marshall', value: 'Marshall County', parent: 'KY' }
];

export const tileDrainageOptions = [
  { key: 'noTileDrain', value: 'No Tile Drain' },
  { key: 'standardDensity', value: 'Standard Density' },
  {
    key: 'standardDensityWithDrainageWaterManagement',
    value: 'Standard Density With Drainage Water Management'
  },
  { key: 'highDensity', value: 'High Density' },
  {
    key: 'highDensityWithDrainageWaterManagement',
    value: 'High Density With Drainage Water Management'
  }
];

export const rentTypeOptions = [
  { key: 'cashRent', value: 'Cash Rent' },
  { key: 'cropShare', value: 'Crop Share' },
  { key: 'other', value: 'Other' }
];

export const bearingOptions = [
  { key: 'E', value: 'East' },
  { key: 'N', value: 'North' },
  { key: 'S', value: 'South' },
  { key: 'W', value: 'West' }
];

export const townshipOptions = [
  { key: '', value: 'None' },
  { key: 'N', value: 'North' },
  { key: 'S', value: 'South' }
];

export const rangeOptions = [
  { key: '', value: 'None' },
  { key: 'E', value: 'East' },
  { key: 'W', value: 'West' }
];

export const waterSourceOptions = [
  { key: 'irrigationDistrict', value: 'Irrigation District' },
  { key: 'municipal', value: 'Municipal' },
  { key: 'onFarmPond', value: 'On Farm Pond' },
  { key: 'reservoir', value: 'Reservoir' },
  { key: 'river', value: 'River' },
  { key: 'stream', value: 'Stream' },
  { key: 'tailwater', value: 'Tailwater' },
  { key: 'well', value: 'Well' }
];

export const waterOriginOptions = [
  { key: 'acquifer', value: 'Acquifer' },
  { key: 'watershed', value: 'Watershed' }
];

export const pumpEnergySourceOptions = [
  { key: 'diesel', value: 'Diesel' },
  { key: 'electric', value: 'Electric' },
  { key: 'naturalGas', value: 'Natural Gas' },
  { key: 'propane', value: 'Propane' }
];

export const irrigationSystemOptions = [
  { key: 'basin', value: 'Basin' },
  { key: 'border', value: 'Border' },
  { key: 'drip', value: 'Drip' },
  { key: 'flood', value: 'Flood' },
  { key: 'furrow', value: 'Furrow' },
  { key: 'linear', value: 'Linear' },
  { key: 'microSprinkler', value: 'Micro Sprinkler' },
  { key: 'pivot', value: 'Pivot' },
  { key: 'subsurface', value: 'Subsurface' },
  { key: 'travelingGun', value: 'Traveling Gun' },
  { key: 'wheelLines', value: 'Wheel Lines' }
];

export const cropYearOptions = [];

export const tillageOptions = [
  { key: 'intensive', value: 'Intensive' },
  { key: 'conventional', value: 'Conventional' },
  { key: 'reduced', value: 'Reduced' },
  { key: 'no-till', value: 'No-Till' }
];

export const soilTextureOptions = [
  { key: 'clay', value: 'Clay' },
  { key: 'silt', value: 'Silt' },
  { key: 'sand', value: 'Sand' },
  { key: 'loam', value: 'Loam' },
  { key: 'siltyClay', value: 'Silty Clay' },
  { key: 'sandyClayLoam', value: 'Sandy Clay Loam' },
  { key: 'siltyClayLoam', value: 'Silty Clay Loam' },
  { key: 'clayLoam', value: 'Clay Loam' },
  { key: 'siltyLoam', value: 'Silty Loam' },
  { key: 'sandyLoam', value: 'Sandy Loam' },
  { key: 'loamySand', value: 'Loamy Sand' }
];

export const cropOptions = [
  { key: 'Alfalfa', value: 'Alfalfa' },
  { key: 'Barley : Feed', value: 'Barley : Feed' },
  { key: 'Blackberry', value: 'Blackberry' },
  { key: 'Chrysanthemum', value: 'Chrysanthemum' },
  { key: 'Clover : Arrowleaf', value: 'Clover : Arrowleaf' },
  { key: 'Cotton : Conv', value: 'Cotton : Conv' },
  { key: 'Edamame', value: 'Edamame' },
  { key: 'Fruit Trees : Apple', value: 'Fruit Trees : Apple' },
  { key: 'Grass Seed Mixed', value: 'Grass Seed Mixed' },
  { key: 'Hay : Oat Hay', value: 'Hay : Oat Hay' },
  { key: 'Melon : Muskmelon', value: 'Melon : Muskmelon' },
  { key: 'Onions', value: 'Onions' },
  { key: 'Potato : Dehydrated', value: 'Potato : Dehydrated' },
  { key: 'Squash', value: 'Squash' },
  { key: 'Sunflower', value: 'Sunflower' },
  { key: 'Turnip Greens', value: 'Turnip Greens' }
];

export const TABLE_COLUMNS = [
  {
    field: 'property',
    title: 'Property',
    level: '1',
    sortable: true
  },
  {
    field: 'acres',
    title: 'Acres',
    level: '0',
    sortable: true
  },
  {
    field: 'crops',
    title: 'Crops',
    level: '0',
    sortable: true
  },
  {
    field: 'cropSeason',
    title: 'Crop Season',
    sortable: true
  },
  {
    field: 'costPerAc',
    title: 'Cost/Ac',
    level: '0',
    sortable: true
  },
  {
    field: 'revenuePerAc',
    title: 'Revenue/Ac',
    level: '0',
    sortable: true
  }
];

export const PROPERTY_TYPE_ORGANIZATION = 'organization';
export const PROPERTY_TYPE_PROPERTY = 'property';
export const PROPERTY_TYPE_FIELD = 'field';
export const PROPERTY_TYPE_CROP_ZONE = 'cropZone';
export const PROPERTY_TYPES = [
  PROPERTY_TYPE_ORGANIZATION,
  PROPERTY_TYPE_PROPERTY,
  PROPERTY_TYPE_FIELD,
  PROPERTY_TYPE_CROP_ZONE
];

export const LAST_COORDINATES_STORED = 'lastCoordinatesStored';

export const PROPERTY_VIEW_MODE = {
  MAP: 'map',
  INFO: 'info',
  COST: 'costAnalysis'
};

export const PROPERTY_MAP_FIELDS_OPTIONS = {
  HIDE: 'hide',
  SHOW_BOUNDARIES: 'showBoundaries',
  SHOW_BOUNDARIES_AND_LABELS: 'showBoundariesAndLabels'
};

const createColorSet = (primaryColors, accentColors) => {
  return primaryColors.map((primary, index) => ({
    primary,
    accent: accentColors[index]
  }));
};

/**
 * All color sets are in the following format:
 * [primary-1, primary-2, primary-3, primary-4]
 * [accent-1,  accent-2,  accent-3,  accent-4]
 * 1 is the lightest shade, 4 is the darkest shade
 */
const REDS = createColorSet(
  ['#FFCCC7', '#FFA39E', '#E43841', '#B5081D'],
  ['#AD071B', '#9B0517', '#FFC6C2', '#F99E97']
);

const ORANGES = createColorSet(
  ['#FDDFA8', '#FFC171', '#FA8C16', '#E87000'],
  ['#F09635', '#CE6B01', '#FEDFB8', '#FFCF92']
);

const YELLOWS = createColorSet(
  ['#FFFFC6', '#FFF675', '#FADF14', '#F6CA0E'],
  ['#CBBC15', '#A49708', '#8E7E00', '#726501']
);

const GREENS = createColorSet(
  ['#D9F7BE', '#95DE64', '#4CB816', '#27921A'],
  ['#2CA61D', '#127106', '#DBFFBB', '#BAEF8A']
);

const TEALS = createColorSet(
  ['#B5F5E0', '#5CDBC6', '#20BAA3', '#068E87'],
  ['#1EA39C', '#0B7973', '#9EF9EA', '#64E7D2']
);

const BLUES = createColorSet(
  ['#BAE0FF', '#91CAFF', '#4096FF', '#0958D9'],
  ['#4988F0', '#206AE2', '#BFE2FF', '#A3D5FF']
);

const PURPLES = createColorSet(
  ['#EFDBFF', '#D3ADF7', '#9254DE', '#531DAB'],
  ['#8045E0', '#7738DF', '#EBD2FF', '#DEB5FF']
);

const BROWNS = createColorSet(
  ['#DFC697', '#C69A66', '#A47953', '#80593D'],
  ['#AA7149', '#904E20', '#F2DAAC', '#E4C387']
);

export const CROP_COLORS = [
  REDS,
  ORANGES,
  YELLOWS,
  GREENS,
  TEALS,
  BLUES,
  PURPLES,
  BROWNS
];
